module.exports = __webpack_public_path__ + "static/media/emsa_logo.bc56980b.png";